import React from 'react'
import BarChartDisplay from './ColumnChartDisplay'

const HorizontalColumnBarChart  = ({ data, chartName ,pointLine,locationName,height,width,chart_data_type}) => {
  return data!==null ? (
    <BarChartDisplay data={data} chartName={chartName} pointLine={pointLine} locationName={locationName}
    height={data.length>15?data.length*40:height} width={width}
    chart_data_type={chart_data_type} />
  ) : (
    <div style={{padding:'10px 10px',fontSize:'18px',fontFamily:'Optum Sans',fontWeight:'700'}}>Data Not Available</div>
  )
}

export default HorizontalColumnBarChart
